import { BEMBlock } from 'helpers/classnames';
import {
    Children, cloneElement, ReactElement, useState,
} from 'react';
import * as React from 'react';
import { HeaderDropdown } from 'palette/HeaderDropdown';
import { MAIN_MENU_ID } from 'palette/HeaderDropdown/constants/menuIds';
import { IconName } from 'palette/Icon';
import './styles/MainHeaderDropdown.scss';

type Id = string;

type HeaderMenuProps = React.PropsWithChildren<{
    isOpen: boolean;
    footerData: {
        iconName: IconName;
        label: string;
    }[];
    v2: boolean;
}>;

function MainHeaderDropdown({
    isOpen, footerData, children, v2 = false,
}: HeaderMenuProps) {
    const [activeLinkId, setActiveLinkId] = useState<Id | null>(null);

    const handleLinkMouseOver = (id: Id) => { setActiveLinkId(id); };

    const handleLinkMouseLeave = () => { setActiveLinkId(null); };

    const [block, BEMElement] = BEMBlock('header-menu', { hidden: !isOpen, 'new-nav': v2 });

    return (
        <HeaderDropdown
            className={block}
            footerData={footerData}
            id={MAIN_MENU_ID}
            isOpen={isOpen}
        >
            <div className={BEMElement('dropdown-body')}>
                {Children.map(children, (child) => {
                    const { props: { id } } = child as ReactElement;

                    return cloneElement(child as ReactElement, {
                        isActive: id === activeLinkId,
                        onMouseOver: () => handleLinkMouseOver(id),
                        onFocus: () => handleLinkMouseOver(id),
                        onMouseLeave: handleLinkMouseLeave,
                        onBlur: handleLinkMouseLeave,
                    });
                })}
            </div>
        </HeaderDropdown>
    );
}

export default MainHeaderDropdown;
